import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { Box, Inline } from '@atlaskit/primitives';
import { ActionName, SmartLinkSize, SmartLinkWidth, SmartLinkDirection } from '../../../../../../constants';
import ActionGroup from '../../action-group';
import Block from '../../block';
import ElementGroup from '../../element-group';
import AIStateIndicator from '../ai-state-indicator';
import { renderElementItems } from '../../utils';
import { messages } from '../../../../../../messages';
import AiIcon from '../../../../../common/ai-icon';
import AISummary from '../../../../../common/ai-summary';
import { useAISummary } from '../../../../../../state/hooks/use-ai-summary';
import { useFlexibleUiContext } from '../../../../../../state/flexible-ui-context';
var AISummaryBlockResolvedView = function AISummaryBlockResolvedView(props) {
  var _props$actions = props.actions,
    actions = _props$actions === void 0 ? [] : _props$actions,
    metadata = props.metadata,
    testId = props.testId,
    onActionMenuOpenChange = props.onActionMenuOpenChange,
    onAIActionChange = props.onAIActionChange,
    _props$size = props.size,
    size = _props$size === void 0 ? SmartLinkSize.Medium : _props$size;
  var _useState = useState('ready'),
    _useState2 = _slicedToArray(_useState, 2),
    aiState = _useState2[0],
    setAIState = _useState2[1];
  var metadataElements = renderElementItems(metadata);
  var context = useFlexibleUiContext();
  var url = (context === null || context === void 0 ? void 0 : context.url) || '';
  var aiSummary = useAISummary({
    url: url
  });
  var content = aiSummary.state.content;
  var onAIActionClick = useCallback(function () {
    setAIState('loading');
    if (onAIActionChange) {
      onAIActionChange('loading');
    }
  }, [onAIActionChange]);
  var combinedActions = useMemo(function () {
    if (aiState === 'ready') {
      var aiAction = {
        content: /*#__PURE__*/React.createElement(FormattedMessage, messages.ai_summarize),
        name: ActionName.CustomAction,
        onClick: onAIActionClick,
        testId: "".concat(testId, "-ai-summary-action"),
        icon: /*#__PURE__*/React.createElement(AiIcon, {
          label: "AiIcon"
        })
      };
      return [aiAction].concat(_toConsumableArray(actions));
    }
    return actions;
  }, [actions, aiState, onAIActionClick, testId]);
  var onDropdownOpenChange = useCallback(function (isOpen) {
    if (onActionMenuOpenChange) {
      onActionMenuOpenChange({
        isOpen: isOpen
      });
    }
  }, [onActionMenuOpenChange]);
  return /*#__PURE__*/React.createElement(Block, _extends({}, props, {
    direction: SmartLinkDirection.Vertical,
    testId: "".concat(testId, "-resolved-view")
  }), /*#__PURE__*/React.createElement(AISummary, {
    content: content
  }), /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    alignInline: "end",
    grow: "fill",
    spread: "space-between"
  }, /*#__PURE__*/React.createElement(Box, null, aiState === 'loading' || aiState === 'done' ? /*#__PURE__*/React.createElement(AIStateIndicator, {
    state: aiState,
    testId: testId
  }) : /*#__PURE__*/React.createElement(ElementGroup, {
    width: SmartLinkWidth.FitToContent
  }, metadataElements)), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(ActionGroup, {
    onDropdownOpenChange: onDropdownOpenChange,
    items: combinedActions,
    appearance: "default",
    size: size
  }))));
};
export default AISummaryBlockResolvedView;